import { type ArticleCardProps } from '3-components/Cards/CardArticle/CardArticle';
import { type ArticleListingQuery } from 'cms/cms';
import { resolveArticlePagesToArticleCards, type ArticlePage, type ArticlePageItems, type ArticleCardResolverSettings } from './articleCardResolver';


export interface ArticleListingData {
    total: number;
    items: ArticleCardProps[];
}

export const resolveArticleListing = (data: ArticleListingQuery, settings: ArticleCardResolverSettings): ArticleListingData | null => {
    const { items, total } = data.ArticlePage as ArticlePage;

    return {
        total: Number(total),
        items: resolveArticlePagesToArticleCards(items as ArticlePageItems, settings),
    };
};
